module.exports = __webpack_public_path__ + "static/img/changeimg.7e6058c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/changeimg.png
// module id = 1kv1
// module chunks = 0